import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import AnimateHeight from 'react-animate-height';
import styles from './reveal.css.js';

var getHasChildren = function getHasChildren(children) {
  return !!children && React.Children.count(children) > 0;
};

var Reveal = /*#__PURE__*/function (_Component) {
  _inherits(Reveal, _Component);

  function Reveal(props) {
    var _this;

    _classCallCheck(this, Reveal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Reveal).call(this, props));
    _this.children = props.children;
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(Reveal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.focus && !getHasChildren(prevProps.children) && getHasChildren(this.props.children)) {
        this.ref.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          accentBar = _this$props.accentBar,
          marginBottom = _this$props.marginBottom,
          marginTop = _this$props.marginTop,
          children = _this$props.children,
          focus = _this$props.focus,
          rest = _objectWithoutProperties(_this$props, ["accentBar", "marginBottom", "marginTop", "children", "focus"]);

      var hasChildren = getHasChildren(children);
      if (hasChildren) this.children = children;
      return React.createElement(AnimateHeight, _extends({
        className: getMarginBottomClass(marginBottom),
        height: hasChildren ? 'auto' : 0,
        "aria-hidden": !children,
        onAnimationEnd: function onAnimationEnd() {
          if (!children) {
            _this2.children = null;

            _this2.forceUpdate();
          }
        }
      }, rest), React.createElement("div", {
        className: cn(styles['Reveal'], _defineProperty({}, styles['Reveal--accentBar'], accentBar)),
        ref: this.ref,
        tabIndex: focus ? '-1' : null
      }, marginTop > 0 && React.createElement("div", {
        className: cn(styles.spacer, getMarginBottomClass(marginTop))
      }), accentBar ? React.createElement("div", {
        className: styles.accentBar
      }, this.children) : this.children));
    }
  }]);

  return Reveal;
}(Component);

_defineProperty(Reveal, "defaultProps", {
  accentBar: false,
  focus: false,
  duration: 200,
  easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  marginTop: 0,
  marginBottom: 0
});

Reveal.propTypes = process.env.NODE_ENV !== "production" ? {
  accentBar: PropTypes.bool,
  focus: PropTypes.bool,
  duration: PropTypes.number,
  easing: PropTypes.string,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginTop: PropTypes.oneOf(marginBottomLevels),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  children: PropTypes.node
} : {};
export default Reveal;